import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
} from "@ey-xd/motif-react";
import { Sparks } from "../../assets/Icons/Sparks";
import { CHAT } from "../../util/constants";
import {
  getRoleBasedInlineSuggestions,
  getRoleBasedPopupSuggestions,
  getSuggestionsByTab,
  getStaticViewTypeFromText,
} from "../Home/smartSuggestionsData";

// Role-based smart suggestions shown under the Super Agent chat input (same set as the home screen)
const SuperAgentSuggestions = ({ onSuggestionSelect, disabled = false }) => {
  const selectedRole = useSelector((state) => state.user.selectedRole);
  const [showDialog, setShowDialog] = useState(false);

  const sendSuggestion = (text) => {
    setShowDialog(false);
    onSuggestionSelect?.(text, getStaticViewTypeFromText(text, selectedRole));
  };

  const handlers = {
    onGenericAction: sendSuggestion,
    onPlanMyDay: () => sendSuggestion("Please plan my day"),
    onOrdersInDataTriage: () => sendSuggestion("Orders in Data Triage"),
    onNewlyAllocatedOrders: () => sendSuggestion("Newly allocated orders"),
    selectedRole,
  };

  const inlineSuggestions = getRoleBasedInlineSuggestions(handlers);
  const popupSuggestions =
    getRoleBasedPopupSuggestions(handlers)[CHAT.AI_SUGGESTIONS] ||
    getSuggestionsByTab(handlers)[CHAT.AI_SUGGESTIONS] ||
    [];

  return (
    <>
      <div className="chatbot-buttons-box super-agent-suggestions">
        {inlineSuggestions.map((suggestion, index) => (
          <button
            key={suggestion.text}
            type="button"
            className={`chatbot-action-button ${index === 0 ? "yellow-button" : ""}`}
            onClick={() => !disabled && suggestion.action?.()}
            disabled={disabled}
          >
            {suggestion.icon} {suggestion.text}
          </button>
        ))}
        <button
          type="button"
          className="chatbot-action-button text-button"
          onClick={() => setShowDialog(true)}
          disabled={disabled}
        >
          {CHAT.SEE_ALL}
        </button>
      </div>

      <MotifModal
        show={showDialog}
        onClose={() => setShowDialog(false)}
        size="auto"
        className="chatbot-see-all-dialog"
      >
        <MotifModalHeader>
          <div className="sparks-icon-wrapper">
            <Sparks width={40} height={40} color="#FFE600" />
          </div>
        </MotifModalHeader>
        <MotifModalBody>
          <div className="smart-suggestions-section">
            <h2 className="smart-suggestions-title">{CHAT.SMART_SUGGESTIONS}</h2>
            <div className="smart-suggestions-buttons">
              <button
                type="button"
                className="chatbot-suggestion-button active"
              >
                {CHAT.AI_SUGGESTIONS}
              </button>
            </div>
          </div>

          <div className="all-actions-content">
            {popupSuggestions.map((suggestion) => (
              <button
                key={suggestion.text}
                type="button"
                className="chatbot-dialog-action-button"
                onClick={() => suggestion.action?.()}
              >
                {suggestion.icon} {suggestion.text}
              </button>
            ))}
          </div>
        </MotifModalBody>
      </MotifModal>
    </>
  );
};

export default SuperAgentSuggestions;
